module.exports = __webpack_public_path__ + "static/media/server-error.87d9f0db.svg";